/* ==========================================================
 * Avalna Discovery Filters — Batch 05a
 * Filter drawer, sort sheet, sticky bar, chips, count updates
 * ========================================================== */

(function () {
  'use strict';

  /* ------ DOM references ------ */
  var avalnaFilterBar = document.getElementById('avalna-filter-bar');
  var avalnaFilterBtn = document.getElementById('avalna-filter-btn');
  var avalnaSortBtn = document.getElementById('avalna-sort-btn');
  var avalnaFilterDrawer = document.getElementById('avalna-filter-drawer');
  var avalnaFilterBackdrop = document.getElementById('avalna-filter-backdrop');
  var avalnaFilterClose = document.getElementById('avalna-filter-close');
  var avalnaFilterReset = document.getElementById('avalna-filter-reset');
  var avalnaFilterApply = document.getElementById('avalna-filter-apply');
  var avalnaSortSheet = document.getElementById('avalna-sort-sheet');
  var avalnaSortBackdrop = document.getElementById('avalna-sort-backdrop');
  var avalnaFilterChips = document.getElementById('avalna-filter-chips');
  var avalnaSentinel = document.getElementById('avalna-filter-bar-sentinel');

  /* ------ Guard: only run on collection pages ------ */
  if (!avalnaFilterBar && !avalnaFilterChips) {
    return;
  }

  /* ------ Sticky bar detection via IntersectionObserver ------ */
  if (avalnaSentinel && avalnaFilterBar) {
    var avalnaObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            avalnaFilterBar.classList.add('avalna-filter-bar--stuck');
          } else {
            avalnaFilterBar.classList.remove('avalna-filter-bar--stuck');
          }
        });
      },
      { threshold: 0 }
    );
    avalnaObserver.observe(avalnaSentinel);
  }

  /* ------ Scroll lock helpers ------ */
  var avalnaScrollLockCount = 0;

  function avalnaLockScroll() {
    avalnaScrollLockCount++;
    if (avalnaScrollLockCount === 1) {
      document.body.style.overflow = 'hidden';
    }
  }

  function avalnaUnlockScroll() {
    avalnaScrollLockCount--;
    if (avalnaScrollLockCount <= 0) {
      avalnaScrollLockCount = 0;
      document.body.style.overflow = '';
    }
  }

  /* ------ Filter Drawer ------ */
  function avalnaOpenFilterDrawer() {
    if (!avalnaFilterDrawer || !avalnaFilterBackdrop) return;
    avalnaFilterDrawer.classList.add('avalna-filter-drawer--open');
    avalnaFilterBackdrop.classList.add('avalna-filter-drawer-backdrop--visible');
    avalnaLockScroll();

    /* Focus trap setup — focus first interactive element */
    var avalnaFirstFocusable = avalnaFilterDrawer.querySelector(
      'button, input, [tabindex]:not([tabindex="-1"])'
    );
    if (avalnaFirstFocusable) {
      avalnaFirstFocusable.focus();
    }
  }

  function avalnaCloseFilterDrawer() {
    if (!avalnaFilterDrawer || !avalnaFilterBackdrop) return;
    avalnaFilterDrawer.classList.remove('avalna-filter-drawer--open');
    avalnaFilterBackdrop.classList.remove('avalna-filter-drawer-backdrop--visible');
    avalnaUnlockScroll();

    /* Restore focus to the filter button */
    if (avalnaFilterBtn) {
      avalnaFilterBtn.focus();
    }
  }

  if (avalnaFilterBtn) {
    avalnaFilterBtn.addEventListener('click', avalnaOpenFilterDrawer);
  }

  if (avalnaFilterClose) {
    avalnaFilterClose.addEventListener('click', avalnaCloseFilterDrawer);
  }

  if (avalnaFilterBackdrop) {
    avalnaFilterBackdrop.addEventListener('click', avalnaCloseFilterDrawer);
  }

  /* ------ Focus Trap ------ */
  if (avalnaFilterDrawer) {
    avalnaFilterDrawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;

      var avalnaFocusables = avalnaFilterDrawer.querySelectorAll(
        'button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (avalnaFocusables.length === 0) return;

      var avalnaFirst = avalnaFocusables[0];
      var avalnaLast = avalnaFocusables[avalnaFocusables.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === avalnaFirst) {
          e.preventDefault();
          avalnaLast.focus();
        }
      } else {
        if (document.activeElement === avalnaLast) {
          e.preventDefault();
          avalnaFirst.focus();
        }
      }
    });
  }

  /* ------ Filter group collapse/expand ------ */
  var avalnaGroupHeaders = document.querySelectorAll('.avalna-filter-drawer__group-header');
  avalnaGroupHeaders.forEach(function (header) {
    header.addEventListener('click', function () {
      var avalnaExpanded = header.getAttribute('aria-expanded') === 'true';
      header.setAttribute('aria-expanded', avalnaExpanded ? 'false' : 'true');
    });
  });

  /* ------ Filter state management ------ */
  function avalnaGetCollectionUrl() {
    /* Get clean collection URL without filter/sort params */
    return window.location.pathname;
  }

  function avalnaGetCurrentParams() {
    return new URLSearchParams(window.location.search);
  }

  function avalnaBuildFilterUrl() {
    var avalnaParams = new URLSearchParams();

    /* Preserve sort_by if present */
    var avalnaCurrentParams = avalnaGetCurrentParams();
    var avalnaSortBy = avalnaCurrentParams.get('sort_by');
    if (avalnaSortBy) {
      avalnaParams.set('sort_by', avalnaSortBy);
    }

    /* Preserve preview_theme_id if present */
    var avalnaPreviewId = avalnaCurrentParams.get('preview_theme_id');
    if (avalnaPreviewId) {
      avalnaParams.set('preview_theme_id', avalnaPreviewId);
    }

    /* Collect all checkbox values from the drawer */
    var avalnaCheckboxes = avalnaFilterDrawer
      ? avalnaFilterDrawer.querySelectorAll('.avalna-filter-drawer__checkbox:checked')
      : [];
    avalnaCheckboxes.forEach(function (cb) {
      avalnaParams.append(cb.name, cb.value);
    });

    /* Collect toggle value */
    var avalnaToggle = avalnaFilterDrawer
      ? avalnaFilterDrawer.querySelector('.avalna-filter-drawer__toggle-input:checked')
      : null;
    if (avalnaToggle) {
      avalnaParams.append(avalnaToggle.name, avalnaToggle.value);
    }

    /* Collect price range values */
    var avalnaPriceInputs = avalnaFilterDrawer
      ? avalnaFilterDrawer.querySelectorAll('.avalna-filter-drawer__price-input')
      : [];
    avalnaPriceInputs.forEach(function (input) {
      if (input.value && input.value.trim() !== '') {
        avalnaParams.append(input.name, input.value);
      }
    });

    var avalnaUrl = avalnaGetCollectionUrl();
    var avalnaParamString = avalnaParams.toString();
    return avalnaParamString ? avalnaUrl + '?' + avalnaParamString : avalnaUrl;
  }

  /* Apply button — navigate with filter params */
  if (avalnaFilterApply) {
    avalnaFilterApply.addEventListener('click', function () {
      window.location.href = avalnaBuildFilterUrl();
    });
  }

  /* Reset all — navigate to clean collection URL */
  if (avalnaFilterReset) {
    avalnaFilterReset.addEventListener('click', function () {
      var avalnaParams = new URLSearchParams();

      /* Preserve sort_by if present */
      var avalnaCurrentParams = avalnaGetCurrentParams();
      var avalnaSortBy = avalnaCurrentParams.get('sort_by');
      if (avalnaSortBy) {
        avalnaParams.set('sort_by', avalnaSortBy);
      }

      /* Preserve preview_theme_id if present */
      var avalnaPreviewId = avalnaCurrentParams.get('preview_theme_id');
      if (avalnaPreviewId) {
        avalnaParams.set('preview_theme_id', avalnaPreviewId);
      }

      var avalnaUrl = avalnaGetCollectionUrl();
      var avalnaParamString = avalnaParams.toString();
      window.location.href = avalnaParamString ? avalnaUrl + '?' + avalnaParamString : avalnaUrl;
    });
  }

  /* ------ Sort Bottom Sheet ------ */
  function avalnaOpenSortSheet() {
    if (!avalnaSortSheet || !avalnaSortBackdrop) return;
    avalnaSortSheet.classList.add('avalna-sort-sheet--open');
    avalnaSortBackdrop.classList.add('avalna-sort-backdrop--visible');
    avalnaLockScroll();
  }

  function avalnaCloseSortSheet() {
    if (!avalnaSortSheet || !avalnaSortBackdrop) return;
    avalnaSortSheet.classList.remove('avalna-sort-sheet--open');
    avalnaSortBackdrop.classList.remove('avalna-sort-backdrop--visible');
    avalnaUnlockScroll();

    if (avalnaSortBtn) {
      avalnaSortBtn.focus();
    }
  }

  if (avalnaSortBtn) {
    avalnaSortBtn.addEventListener('click', avalnaOpenSortSheet);
  }

  if (avalnaSortBackdrop) {
    avalnaSortBackdrop.addEventListener('click', avalnaCloseSortSheet);
  }

  /* Sort option selection */
  var avalnaSortOptions = document.querySelectorAll('.avalna-sort-sheet__option');
  avalnaSortOptions.forEach(function (option) {
    option.addEventListener('click', function () {
      var avalnaSortValue = option.getAttribute('data-sort-value');
      var avalnaParams = avalnaGetCurrentParams();

      /* Set sort_by */
      if (avalnaSortValue === 'manual') {
        avalnaParams.delete('sort_by');
      } else {
        avalnaParams.set('sort_by', avalnaSortValue);
      }

      var avalnaUrl = avalnaGetCollectionUrl();
      var avalnaParamString = avalnaParams.toString();
      window.location.href = avalnaParamString ? avalnaUrl + '?' + avalnaParamString : avalnaUrl;
    });
  });

  /* ------ Escape key closes both ------ */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (
        avalnaFilterDrawer &&
        avalnaFilterDrawer.classList.contains('avalna-filter-drawer--open')
      ) {
        avalnaCloseFilterDrawer();
      }
      if (avalnaSortSheet && avalnaSortSheet.classList.contains('avalna-sort-sheet--open')) {
        avalnaCloseSortSheet();
      }
    }
  });

  /* ------ Active Filter Chips ------ */
  function avalnaGetChipLabel(paramName, paramValue) {
    var avalnaFilterDataEl = document.getElementById('avalna-filter-data');
    var avalnaFilterData = { filters: [] };
    if (avalnaFilterDataEl) {
      try {
        avalnaFilterData = JSON.parse(avalnaFilterDataEl.textContent || '{"filters":[]}');
      } catch (e) {
        /* Ignore parse error */
      }
    }

    for (var i = 0; i < avalnaFilterData.filters.length; i++) {
      var filter = avalnaFilterData.filters[i];
      for (var j = 0; j < filter.values.length; j++) {
        var value = filter.values[j];
        if (value.param_name === paramName && String(value.value) === String(paramValue)) {
          return value.label;
        }
      }
      /* For price range filters */
      if (filter.param_name === paramName || paramName.indexOf(filter.param_name) === 0) {
        if (paramName.indexOf('.gte') !== -1) return 'From ₹' + paramValue;
        if (paramName.indexOf('.lte') !== -1) return 'Under ₹' + paramValue;
      }
    }
    return paramValue;
  }

  function avalnaInitChips() {
    if (!avalnaFilterChips) return;

    var avalnaParams = avalnaGetCurrentParams();
    var avalnaChipData = [];

    /* Iterate URL params and find filter params */
    avalnaParams.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) {
        var avalnaLabel = avalnaGetChipLabel(key, value);
        avalnaChipData.push({ param: key, value: value, label: avalnaLabel });
      }
    });

    if (avalnaChipData.length === 0) {
      avalnaFilterChips.style.display = 'none';
      return;
    }

    /* Build chip elements */
    avalnaFilterChips.innerHTML = '';
    avalnaFilterChips.style.display = '';

    avalnaChipData.forEach(function (chip) {
      var avalnaChipBtn = document.createElement('button');
      avalnaChipBtn.className = 'avalna-filter-chips__chip';
      avalnaChipBtn.setAttribute('data-filter-param', chip.param);
      avalnaChipBtn.setAttribute('data-filter-value', chip.value);
      avalnaChipBtn.innerHTML =
        chip.label +
        ' <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">' +
        '<line x1="2.5" y1="2.5" x2="7.5" y2="7.5" stroke="currentColor" stroke-width="1.2"/>' +
        '<line x1="7.5" y1="2.5" x2="2.5" y2="7.5" stroke="currentColor" stroke-width="1.2"/></svg>';
      avalnaChipBtn.addEventListener('click', function () {
        avalnaRemoveFilter(chip.param, chip.value);
      });
      avalnaFilterChips.appendChild(avalnaChipBtn);
    });

    /* Add "Clear all" chip */
    var avalnaClearBtn = document.createElement('button');
    avalnaClearBtn.className = 'avalna-filter-chips__clear';
    avalnaClearBtn.id = 'avalna-clear-filters';
    avalnaClearBtn.textContent = 'Clear all';
    avalnaClearBtn.addEventListener('click', function () {
      avalnaClearAllFilters();
    });
    avalnaFilterChips.appendChild(avalnaClearBtn);
  }

  function avalnaRemoveFilter(paramName, paramValue) {
    var avalnaParams = avalnaGetCurrentParams();
    var avalnaNewParams = new URLSearchParams();

    avalnaParams.forEach(function (value, key) {
      if (key === paramName && value === paramValue) {
        /* Skip this one */
        return;
      }
      avalnaNewParams.append(key, value);
    });

    var avalnaUrl = avalnaGetCollectionUrl();
    var avalnaParamString = avalnaNewParams.toString();
    window.location.href = avalnaParamString ? avalnaUrl + '?' + avalnaParamString : avalnaUrl;
  }

  function avalnaClearAllFilters() {
    var avalnaParams = avalnaGetCurrentParams();
    var avalnaNewParams = new URLSearchParams();

    /* Preserve only non-filter params (sort_by, preview_theme_id, etc.) */
    avalnaParams.forEach(function (value, key) {
      if (!key.startsWith('filter.')) {
        avalnaNewParams.append(key, value);
      }
    });

    var avalnaUrl = avalnaGetCollectionUrl();
    var avalnaParamString = avalnaNewParams.toString();
    window.location.href = avalnaParamString ? avalnaUrl + '?' + avalnaParamString : avalnaUrl;
  }

  /* Initialize chips on page load */
  avalnaInitChips();
})();
